import React from "react";
import { Activity, Minus, Trash2, Edit2 } from "lucide-react";

const DeductionsList = ({
  t,
  currentTheme,
  formStyles,
  isRTL,
  loading,
  deductions,
  onDeleteDeduction,
  onEditDeduction,
}) => {
  return (
    <>
      {/* Deductions List */}
      <div style={formStyles.section}>
            <h3
              style={{
                margin: "0 0 20px 0",
                color: currentTheme.colors.textPrimary,
                fontSize: "20px",
                fontWeight: "700",
              }}
            >
              {t("currentDeductions")} ({deductions.length})
            </h3>

            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px",
                  color: currentTheme.colors.textSecondary,
                }}
              >
                <Activity
                  size={32}
                  style={{ animation: "spin 1s linear infinite" }}
                />
                <p>{t("loading")}</p>
              </div>
            ) : deductions.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px",
                  color: currentTheme.colors.textSecondary,
                }}
              >
                <Minus
                  size={48}
                  style={{ opacity: 0.3, marginBottom: "16px" }}
                />
                <p>{t("noDeductions")}</p>
              </div>
            ) : (
              deductions.map((deduction, index) => (
                <div
                  key={index}
                  style={formStyles.deductionCard}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = currentTheme.shadows.card;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          marginBottom: "8px",
                        }}
                      >
                        <span
                          style={{
                            background: `${currentTheme.colors.danger}20`,
                            color: currentTheme.colors.danger,
                            padding: "6px 12px",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: "700",
                            textTransform: "uppercase",
                          }}
                        >
                          {t(deduction.type)}
                        </span>
                        {deduction.days && (
                          <span
                            style={{
                              fontSize: "13px",
                              color: currentTheme.colors.textMuted,
                            }}
                          >
                            {deduction.days} {t("days")}
                          </span>
                        )}
                      </div>

                      <div
                        style={{
                          fontSize: "15px",
                          color: currentTheme.colors.textPrimary,
                          marginBottom: "8px",
                          fontWeight: "600",
                        }}
                      >
                        {deduction.description || t("noDescription")}
                      </div>

                      <div
                        style={{
                          fontSize: "13px",
                          color: currentTheme.colors.textMuted,
                        }}
                      >
                        {t("date")}:{" "}
                        {deduction.attendance?.date
                          ? new Date(
                              deduction.attendance.date,
                            ).toLocaleDateString(isRTL ? "ar-EG" : "en-GB")
                          : "N/A"}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "24px",
                          fontWeight: "800",
                          color: currentTheme.colors.danger,
                          fontFamily: "monospace",
                        }}
                      >
                        -{Number(deduction.amount || 0).toLocaleString()}{" "}
                        {t("currency")}
                      </div>

                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (onEditDeduction) {
                              onEditDeduction(deduction);
                            }
                          }}
                          style={{
                            background: "transparent",
                            border: `1px solid ${currentTheme.colors.border}`,
                            cursor: "pointer",
                            color: currentTheme.colors.textSecondary,
                            padding: "6px 12px",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = currentTheme.colors.hover || "rgba(0,0,0,0.05)")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          title={t("edit")}
                        >
                          <Edit2 size={16} />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (onDeleteDeduction) {
                              onDeleteDeduction(deduction._id || deduction.id);
                            }
                          }}
                          style={{
                            background: "transparent",
                            border: `1px solid ${currentTheme.colors.border}`,
                            cursor: "pointer",
                            color: currentTheme.colors.textSecondary,
                            padding: "6px 12px",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = currentTheme.colors.hover || "rgba(0,0,0,0.05)")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          title={t("delete")}
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
    </>
  );
};

export default DeductionsList;